import React from "react";
import ContactForm from "@/components/sections/ContactForm";
import { useLang } from "@/contexts/LanguageContext";

const Contact = () => {
  const { t } = useLang();
  return (
    <div data-testid="contact-page">
      <section className="bg-brand-surface border-b border-brand-border">
        <div className="container-x pt-24 pb-16 sm:pt-32 sm:pb-20">
          <p className="overline">{t.contact.eyebrow}</p>
          <h1 className="mt-5 font-heading font-bold text-brand-ink text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.02] max-w-4xl">
            {t.contact.title}
          </h1>
          <p className="mt-7 text-lg text-brand-muted max-w-2xl leading-relaxed">
            {t.contact.subtitle}
          </p>
        </div>
      </section>
      <ContactForm />
    </div>
  );
};

export default Contact;
